import React from "react"

const CompanyContact = ({ content, className }) => (
  <React.Fragment>
    <ul class="icons bulleted">
      <li class="icon solid fa-map-marker-alt">
        <h3>Address</h3>
        <p>
          JKLM Contracts Ltd
          <br />
          213 Lochend Road
          <br />
          Glasgow
          <br />
          G69 8BE
        </p>
      </li>
    </ul>
    <ul class="icons bulleted">
      <li class="icon solid fa-phone">
        <h3>Phone</h3>
        <p>01236 793 084</p>
      </li>
      <li class="icon solid fa-envelope">
        <h3>Email</h3>
        <p>
          <a href="mailto:martin@jklmltd.com">martin@jklmltd.com</a>
        </p>
      </li>
    </ul>
  </React.Fragment>
)

export default CompanyContact
